import { canUseDOM } from '@ps/web-core-utils';
import { useNavigate, usePostMessage } from '@ps/web-shared-components';
import { setCustomUrl } from '@snowplow/browser-tracker';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import URL from 'url-parse';

import { select } from '@swf/core/store';

const useWizardExit = () => {
  const navigate = useNavigate();
  const href = useSelector(select.location.getHref);
  const redirectTo = useSelector(select.cms.getRedirectUrl);
  const postMessage = usePostMessage();
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const aliases = useSelector(select.cms.getAliases);

  const handleMobileOrEmbedded = useCallback(() => {
    if (redirectTo === aliases.firstWalletHome) {
      navigate(redirectTo);
    } else {
      postMessage('close');
      window.close();
    }
  }, [aliases, navigate, postMessage, redirectTo]);

  const handleWebNavigation = useCallback(() => {
    const url = new URL(href);
    url.set('pathname', redirectTo);
    navigate(url.pathname);
    setCustomUrl(url.pathname);
  }, [href, redirectTo, navigate]);

  return useCallback(() => {
    const isOpenerDifferentWindow = canUseDOM && window.opener && window.opener !== window;

    if (isMobileEmbedded || isOpenerDifferentWindow) {
      handleMobileOrEmbedded();
    } else if (canUseDOM) {
      handleWebNavigation();
    }
  }, [handleMobileOrEmbedded, handleWebNavigation, isMobileEmbedded]);
};

export default useWizardExit;
